import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0F172A] text-white">
      <div className="container-wide py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img 
                src="https://irishconnexxion.com.au/wp-content/uploads/2021/06/Asset-1@3x.png" 
                alt="Irish Connexxion" 
                className="h-10 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-sm text-[#94A3B8] leading-relaxed">
              Premium Wholesale Clothing Solutions for Travel Retail
            </p>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-white">Products</h4>
            <ul className="space-y-2">
              <li><Link to="/products?category=t-shirts" className="text-sm text-[#94A3B8] hover:text-white transition-colors">T-Shirts</Link></li>
              <li><Link to="/products?category=hoodies" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Hoodies</Link></li>
              <li><Link to="/products?category=sweatshirts" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Sweatshirts</Link></li>
              <li><Link to="/products?category=caps" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Caps</Link></li>
              <li><Link to="/products?category=bags" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Bags</Link></li>
            </ul>
          </div>

          {/* Account */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-white">Account</h4>
            <ul className="space-y-2">
              <li><Link to="/login" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Login</Link></li>
              <li><Link to="/register" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Register</Link></li>
              <li><Link to="/orders" className="text-sm text-[#94A3B8] hover:text-white transition-colors">My Orders</Link></li>
              <li><Link to="/dashboard" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Dashboard</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-white">Contact</h4>
            <ul className="space-y-2 text-sm text-[#94A3B8]">
              <li>orders@irishconnexxion.com.au</li>
              <li>03 9042 3821</li>
              <li>Mon - Fri: 9am - 6pm</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#1E293B] mt-12 pt-8">
          <p className="text-sm text-[#64748B] text-center">
            © 2026 Irish Connexxion. All rights reserved. B2B Wholesale Portal.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
